// extracted by mini-css-extract-plugin
export default {"card":"vacancyCard_card__2JnOS","info":"vacancyCard_info__F3tRF"};